// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image__wrap[data-v-73875e39]{text-align:center}.image__wrap[data-v-73875e39],img[data-v-73875e39]{height:100%;width:100%}img[data-v-73875e39]{max-height:100%;max-width:100%;object-fit:cover}@media only screen and (max-width:1024px){img[data-v-73875e39]{object-fit:contain}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
